const routes = []

routes.push({
  path: '/',
  redirect: '/home'
})

// auth
routes.push({
  path: '/',
  component: () => import('@/layouts/auth'),
  children: [
    {
      path: 'login',
      name: 'login',
      meta: {
        title: 'Login',
        group: 'auth'
      },
      component: () => import('@/pages/auth/loginpage')
    }
  ]
})

routes.push({
  path: '/callback',
  name: 'callback',
  meta: {
    title: 'Oauth',
    group: 'oauth'
  },
  component: () => import('@/pages/oauth')
})

routes.push({
  path: '/forgot-password',
  name: 'forgot.password',
  meta: {
    title: 'Forgot Password',
    group: 'forgot'
  },
  component: () => import('@/pages/auth/ForgotPassword')
})

routes.push({
  path: '/reset-password/:token',
  name: 'reset.password',
  props(route) {
    return route.query || {}
  },
  meta: {
    title: 'Reset Password',
    group: 'forgot'
  },
  component: () => import('@/pages/auth/ResetPassword')
})

routes.push({
  path: '/',
  meta: { auth: true },
  component: () => import('@/layouts/base'),
  children: [
    {
      path: '/geographic/customers',
      name: 'geographic.customers',
      meta: {
        title: 'Geographic Customer',
        group: 'geographic'
      },
      component: () => import('@/pages/geographic/customers')
    },
    {
      path: '/geographic/prospek-banks',
      name: 'geographic.pb',
      meta: {
        title: 'Geographic Prospek Bank',
        group: 'geographic'
      },
      component: () => import('@/pages/geographic/pb')
    },
    {
      path: '/geographic/instruments',
      name: 'geographic.instruments',
      meta: {
        title: 'Geographic Instruments',
        group: 'geographic'
      },
      component: () => import('@/pages/geographic/instruments')
    },

    {
      path: 'agreements/docx/:number/:id',
      name: 'docx.agreement',
      meta: {
        title: 'Agreement Commercial',
        group: 'agreement'
      },
      component: () => import('@/pages/agreement/agreementDocx')
    }
  ]
})

routes.push({
  path: '/',
  component: () => import('@/layouts/default'),
  meta: { auth: true },
  children: [
    // dashboard
    {
      path: 'home',
      name: 'home',
      meta: {
        title: 'Dashboard',
        group: 'home'
      },
      component: () => import('@/pages/dashboard')
    },

    // roles
    {
      path: 'roles',
      name: 'read.role',
      meta: {
        title: 'Roles',
        group: 'roles'
      },
      component: () => import('@/pages/roles/index')
    },
    {
      path: 'roles/add',
      name: 'add.role',
      meta: {
        title: 'Roles',
        group: 'roles'
      },
      component: () => import('@/pages/roles/add')
    },
    {
      path: 'roles/:name/edit',
      name: 'edit.role',
      meta: {
        title: 'Roles',
        group: 'roles'
      },
      component: () => import('@/pages/roles/edit')
    },
    {
      path: 'roles/:name/permission',
      name: 'role.permission',
      meta: {
        title: 'Roles',
        group: 'roles'
      },
      component: () => import('@/pages/roles/permissions')
    },

    // permissions
    {
      path: 'permissions',
      name: 'read.permission',
      meta: {
        title: 'Permissions',
        group: 'permissions'
      },
      component: () => import('@/pages/permissions/index')
    },
    {
      path: 'permissions/add',
      name: 'add.permission',
      meta: {
        title: 'Permissions',
        group: 'permissions'
      },
      component: () => import('@/pages/permissions/add')
    },
    {
      path: 'permissions/:name/edit',
      name: 'edit.permission',
      meta: {
        title: 'Permissions',
        group: 'permissions'
      },
      component: () => import('@/pages/permissions/edit')
    },

    // area
    {
      path: 'area',
      name: 'read.area',
      meta: {
        title: 'Area',
        group: 'area'
      },
      component: () => import('@/pages/area/index')
    },
    {
      path: 'area/add',
      name: 'add.area',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Area',
        group: 'area'
      },
      component: () => import('@/pages/area/add')
    },
    {
      path: 'area/edit',
      name: 'edit.area',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Area',
        group: 'area'
      },
      component: () => import('@/pages/area/edit')
    },
    // area for see child
    {
      path: 'area/:name',
      name: 'read.area_child',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Area',
        group: 'area',
        child: true
      },
      component: () => import('@/pages/area/indexChild')
    },

    // area level
    {
      path: 'area/level',
      name: 'read.area.level',
      meta: {
        title: 'Area Level',
        group: 'areaLevel'
      },
      component: () => import('@/pages/area/level/index')
    },
    {
      path: 'area/level/add',
      name: 'add.area.level',
      meta: {
        title: 'Area Level',
        group: 'areaLevel'
      },
      component: () => import('@/pages/area/level/add')
    },
    {
      path: 'area/level/:name/edit',
      name: 'edit.area.level',
      meta: {
        title: 'Area Level',
        group: 'areaLevel'
      },
      component: () => import('@/pages/area/level/edit')
    },

    // customer
    {
      path: 'customer',
      name: 'read.customer',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Customer',
        group: 'customer'
      },
      component: () => import('@/pages/customer/index')
    },
    {
      path: 'customer/add',
      name: 'add.customer',
      meta: {
        title: 'Customer',
        group: 'customer'
      },
      component: () => import('@/pages/customer/add')
    },

    {
      path: 'customer/detail/:name/:id',
      name: 'show.customer',
      meta: {
        title: 'Customer',
        group: 'customer'
      },
      component: () => import('@/pages/customer/show')
    },

    {
      path: 'customer/project/:name/:id',
      name: 'project.customer',
      meta: {
        title: 'Customer',
        group: 'customer'
      },
      component: () => import('@/pages/customer/project')
    },

    {
      path: 'customer/type',
      name: 'read.customerType',
      meta: {
        title: 'Customer Type',
        group: 'customerType'
      },
      component: () => import('@/pages/customer/type/index')
    },
    {
      path: 'customer/type/add',
      name: 'add.customer.type',
      meta: {
        title: 'Customer Type',
        group: 'customerType'
      },
      component: () => import('@/pages/customer/type/add')
    },
    {
      path: 'customer/type/:name/edit',
      name: 'edit.customer.type',
      meta: {
        title: 'Customer Type',
        group: 'customerType'
      },
      component: () => import('@/pages/customer/type/edit')
    },

    {
      path: 'customer/rating',
      name: 'read.customerRating',
      meta: {
        title: 'Customer Rating',
        group: 'customerRating'
      },
      component: () => import('@/pages/customer/rating/index')
    },
    {
      path: 'customer/rating/add',
      name: 'add.customer.rating',
      meta: {
        title: 'Customer Rating',
        group: 'customerRating'
      },
      component: () => import('@/pages/customer/rating/add')
    },
    {
      path: 'customer/rating/:name/edit',
      name: 'edit.customer.rating',
      meta: {
        title: 'Customer Rating',
        group: 'customerRating'
      },
      component: () => import('@/pages/customer/rating/edit')
    },

    {
      path: 'customer/greeting',
      name: 'read.customerGreeting',
      meta: {
        title: 'Customer Greeting',
        group: 'customerGreeting'
      },
      component: () => import('@/pages/customer/greeting/index')
    },
    {
      path: 'customer/greeting/add',
      name: 'add.customer.greeting',
      meta: {
        title: 'Customer Greeting',
        group: 'customerGreeting'
      },
      component: () => import('@/pages/customer/greeting/add')
    },
    {
      path: 'customer/greeting/:name/edit',
      name: 'edit.customer.greeting',
      meta: {
        title: 'Customer Greeting',
        group: 'customerGreeting'
      },
      component: () => import('@/pages/customer/greeting/edit')
    },

    // employee
    {
      path: 'employee',
      name: 'read.employee',
      meta: {
        title: 'Employee',
        group: 'employee'
      },
      component: () => import('@/pages/employee/index')
    },
    {
      path: 'employee/add',
      name: 'add.employee',
      meta: {
        title: 'Employee',
        group: 'employee'
      },
      component: () => import('@/pages/employee/add')
    },
    {
      path: 'employe/:name/edit',
      name: 'edit.employee',
      meta: {
        title: 'Employee',
        group: 'employee'
      },
      component: () => import('@/pages/employee/edit')
    },

    // positons
    {
      path: 'employee/position',
      name: 'read.position',
      meta: {
        title: 'Employee Position',
        group: 'position'
      },
      component: () => import('@/pages/employee/positions/index')
    },
    {
      path: 'employee/position/add',
      name: 'add.position',
      meta: {
        title: 'Employee Position',
        group: 'position'
      },
      component: () => import('@/pages/employee/positions/add')
    },
    {
      path: 'employe/position/:name/edit',
      name: 'edit.position',
      meta: {
        title: 'Employee Position',
        group: 'position'
      },
      component: () => import('@/pages/employee/positions/edit')
    },
    {
      path: 'activity',
      name: 'read.activity',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Activity',
        group: 'activity'
      },
      component: () => import('@/pages/activity/index')
    },
    {
      path: 'weekly',
      component: () => import('@/pages/weekly/mainView'),
      children: [
        {
          path: 'mom',
          name: 'weekly.mom',
          props(route) {
            return route.query || {}
          },
          meta: {
            title: 'Weekly MOM',
            group: 'weekly'
          },
          component: () => import('@/pages/weekly/mom')
        },
        {
          path: 'finalization',
          name: 'weekly.finalization',
          props(route) {
            return route.query || {}
          },
          meta: {
            title: 'Weekly Finalization',
            group: 'weekly'
          },
          component: () => import('@/pages/weekly/finalization')
        },
        {
          path: 'perfomance',
          name: 'weekly.perfomance',
          props(route) {
            return route.query || {}
          },
          meta: {
            title: 'Weekly Perfomance',
            group: 'weekly'
          },
          component: () => import('@/pages/weekly/perfomance')
        }
      ]
    },

    // activity

    {
      path: 'activity/detail/:id/:customer/:name',
      name: 'show.activity',
      meta: {
        title: 'Activity',
        group: 'activity'
      },
      component: () => import('@/pages/activity/show')
    },
    {
      path: 'activity/edit/:id/:name',
      name: 'edit.activity',
      meta: {
        title: 'Activity',
        group: 'activity'
      },
      component: () => import('@/pages/activity/edit')
    },

    {
      path: 'activity/daily',
      name: 'read.activity.daily',
      meta: {
        title: 'Daily Activity',
        group: 'activityDaily'
      },
      component: () => import('@/pages/activity/daily/index')
    },
    {
      path: 'activity/daily/add',
      name: 'add.activity.daily',
      meta: {
        title: 'Daily Activity',
        group: 'activityDaily'
      },
      component: () => import('@/pages/activity/daily/add')
    },
    {
      path: 'activity/daily/:name/edit',
      name: 'edit.activity.daily',
      meta: {
        title: 'Daily Activity',
        group: 'activityDaily'
      },
      component: () => import('@/pages/activity/daily/edit')
    },
    {
      path: 'activity/daily-type',
      name: 'read.activity.dailyType',
      meta: {
        title: 'Activity Type',
        group: 'activityType'
      },
      component: () => import('@/pages/activity/dailyType/index')
    },
    {
      path: 'activity/daily-type',
      name: 'add.activity.dailyType',
      meta: {
        title: 'Activity Type',
        group: 'activityType'
      },
      component: () => import('@/pages/activity/dailyType/add')
    },
    {
      path: 'activity/daily-type/:name/edit',
      name: 'edit.activity.dailyType',
      meta: {
        title: 'Activity Type',
        group: 'activityType'
      },
      component: () => import('@/pages/activity/dailyType/edit')
    },
    {
      path: 'activity/actions',
      name: 'read.action',
      meta: {
        title: 'Action',
        group: 'activityAction'
      },
      component: () => import('@/pages/activity/action')
    },
    {
      path: 'activity/actions/add',
      name: 'add.action',
      meta: {
        title: 'Action',
        group: 'activityAction'
      },
      component: () => import('@/pages/activity/action/add')
    },
    {
      path: 'activity/actions/:name/edit',
      name: 'edit.action',
      meta: {
        title: 'Action',
        group: 'activityAction'
      },
      component: () => import('@/pages/activity/action/edit')
    },
    {
      path: 'activity/today',
      name: 'read.activity.today',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Today Activity',
        group: 'today'
      },
      component: () => import('@/pages/activity/today')
    },
    {
      path: 'activity/monthly',
      name: 'read.activity.monthly',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Monthly Activity',
        group: 'monthly'
      },
      component: () => import('@/pages/activity/activityMonthly')
    },
    {
      path: 'dev/mock-gps',
      name: 'read.mock',
      meta: {
        title: 'Mock GPS',
        group: 'mock'
      },
      component: () => import('@/pages/developer/mock-gps')
    },
    {
      path: 'dev/config',
      name: 'manage.config',
      meta: {
        title: 'Laravelino',
        group: 'mconfig'
      },
      component: () => import('@/pages/developer/config')
    },
    {
      path: 'dev/attendance',
      name: 'read.attendance',
      meta: {
        title: 'Ismart Attendance',
        group: 'attendance'
      },
      component: () => import('@/pages/developer/attendance')
    },

    // instruments brand
    {
      path: 'master/brand',
      name: 'read.brand',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Principal',
        group: 'brand'
      },
      component: () => import('@/pages/master/brand/index')
    },
    {
      path: 'master/brand/add',
      name: 'add.brand',
      meta: {
        title: 'Principal',
        group: 'brand'
      },
      component: () => import('@/pages/master/brand/add')
    },
    {
      path: 'master/brand/edit/:name',
      name: 'edit.brand',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Principal',
        group: 'brand'
      },
      component: () => import('@/pages/master/brand/edit')
    },

    // instrument segment
    {
      path: 'master/segment',
      name: 'read.segment',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Segment',
        group: 'segment'
      },
      component: () => import('@/pages/master/segment/index')
    },
    {
      path: 'master/segment/add',
      name: 'add.segment',
      meta: {
        title: 'Segment',
        group: 'segment'
      },
      component: () => import('@/pages/master/segment/add')
    },
    {
      path: 'master/segment/:name/edit',
      name: 'edit.segment',
      meta: {
        title: 'Segment',
        group: 'segment'
      },
      component: () => import('@/pages/master/segment/edit')
    },

    // line business
    {
      path: 'master/line-business',
      name: 'read.category',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Line Business',
        group: 'category'
      },
      component: () => import('@/pages/master/category/index')
    },
    {
      path: 'master/line-business/add',
      name: 'add.category',
      meta: {
        title: 'Line Business',
        group: 'category'
      },
      component: () => import('@/pages/master/category/add')
    },
    {
      path: 'master/line-business/:name/edit',
      name: 'edit.category',
      meta: {
        title: 'Line Business',
        group: 'category'
      },
      component: () => import('@/pages/master/category/edit')
    },

    // instruments
    {
      path: 'master/instrument',
      name: 'read.instrument',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Instrument',
        group: 'instrument'
      },
      component: () => import('@/pages/master/instrument/index')
    },
    {
      path: 'master/instrument/add',
      name: 'add.instrument',
      meta: {
        title: 'Instrument',
        group: 'instrument'
      },
      component: () => import('@/pages/master/instrument/add')
    },
    {
      path: 'master/instrument/edit/:name',
      name: 'edit.instrument',
      meta: {
        title: 'Instrument',
        group: 'instrument'
      },
      component: () => import('@/pages/master/instrument/edit')
    },

    {
      path: '/profile/:id',
      name: 'read.profile',
      meta: {
        title: 'Profile',
        group: 'profile'
      },
      component: () => import('@/pages/profile/index')
    },

    {
      path: '/profile/activity/:id',
      name: 'read.profile.schedule',
      meta: {
        title: 'Timeline Activity',
        group: 'profileActivity'
      },
      component: () => import('@/pages/profile/activity')
    },

    // manage bundling
    {
      path: 'bundlings',
      name: 'read.bundling',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Bundling',
        group: 'prospekBundling'
      },
      component: () => import('@/pages/prospek/bundling/index')
    },
    {
      path: 'bundlings/add',
      name: 'add.bundling',
      meta: {
        title: 'Bundling',
        group: 'prospekBundling'
      },
      component: () => import('@/pages/prospek/bundling/add')
    },
    {
      path: 'bundlings/:name/edit',
      name: 'edit.bundling',
      meta: {
        title: 'Bundling',
        group: 'prospekBundling'
      },
      component: () => import('@/pages/prospek/bundling/edit')
    },

    // manage selling
    {
      path: 'sellings',
      name: 'read.selling',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Selling',
        group: 'prospekSelling'
      },
      component: () => import('@/pages/prospek/selling/index')
    },
    {
      path: 'sellings/add',
      name: 'add.selling',
      meta: {
        title: 'Selling',
        group: 'prospekSelling'
      },
      component: () => import('@/pages/prospek/selling/add')
    },
    {
      path: 'sellings/:name/edit',
      name: 'edit.selling',
      meta: {
        title: 'Selling',
        group: 'prospekSelling'
      },
      component: () => import('@/pages/prospek/selling/edit')
    },
    {
      path: 'pb-status',
      name: 'read.PBStatus',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'PB Status',
        group: 'PBStatus'
      },
      component: () => import('@/pages/prospek/status/index')
    },
    {
      path: 'pb-status/add',
      name: 'add.PBStatus',
      meta: {
        title: 'PB Status',
        group: 'PBStatus'
      },
      component: () => import('@/pages/prospek/status/add')
    },
    {
      path: 'pb-status/:name/edit',
      name: 'edit.PBStatus',
      meta: {
        title: 'PB Status',
        group: 'PBStatus'
      },
      component: () => import('@/pages/prospek/status/edit')
    },

    // manage prospek banks
    {
      path: 'prospek-banks',
      name: 'read.prospek-bank',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Prospek Bank',
        group: 'prospek-bank'
      },
      component: () => import('@/pages/prospek/prospek-bank/index')
    },
    {
      path: 'prospek-banks/add',
      name: 'add.prospek-bank',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Prospek Bank',
        group: 'prospek-bank'
      },
      component: () => import('@/pages/prospek/prospek-bank/add')
    },
    {
      path: 'prospek-banks/detail/:number/:id',
      name: 'show.prospek-bank',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Prospek Bank',
        group: 'prospek-bank'
      },
      component: () => import('@/pages/prospek/prospek-bank/detail')
    },
    {
      path: 'prospek-banks/edit/:number/:id',
      name: 'edit.prospek-bank',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Prospek Bank',
        group: 'prospek-bank'
      },
      component: () => import('@/pages/prospek/prospek-bank/edit')
    },
    {
      path: 'prospek-banks/dashboard',
      name: 'dashboard.prospek-bank',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Prospek Bank',
        group: 'prospek-bank'
      },
      component: () => import('@/pages/prospek/prospek-bank/dashboard')
    },

    // target sales
    {
      path: 'target',
      name: 'manage.target',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Target Sales',
        group: 'target-sales'
      },
      component: () => import('@/pages/target')
    },

    // banner
    {
      path: 'banner',
      name: 'read.banner',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Banner',
        group: 'banner'
      },
      component: () => import('@/pages/banner/index')
    },
    {
      path: 'banner/add',
      name: 'add.banner',
      meta: {
        title: 'Banner',
        group: 'banner'
      },
      component: () => import('@/pages/banner/add')
    },
    {
      path: 'banner/edit/:name',
      name: 'edit.banner',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Banner',
        group: 'banner'
      },
      component: () => import('@/pages/banner/edit')
    },

    //
    {
      path: 'group-principals',
      name: 'read.group.principal',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Group Principal',
        group: 'groupPrincipal'
      },
      component: () => import('@/pages/group-principal/index')
    },
    {
      path: 'group-principals/add',
      name: 'add.group.principal',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Group Principal',
        group: 'groupPrincipal'
      },
      component: () => import('@/pages/group-principal/add')
    },
    {
      path: 'group-principals/:name/edit',
      name: 'edit.group.principal',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Group Principal',
        group: 'groupPrincipal'
      },
      component: () => import('@/pages/group-principal/edit')
    },
    //
    {
      path: 'tickets',
      name: 'read.tickets',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Tickets',
        group: 'tickets'
      },
      component: () => import('@/pages/ticket/index')
    },
    {
      path: 'tickets/:id',
      name: 'show.ticket',
      meta: {
        title: 'Ticket Detail',
        group: 'tickets'
      },
      component: () => import('@/pages/ticket/detail')
    },
    //
    {
      path: 'agreements',
      name: 'read.agreement',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Agreement Commercial',
        group: 'agreement'
      },
      component: () => import('@/pages/agreement/index')
    },
    {
      path: 'agreements/add',
      name: 'add.agreement',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Agreement',
        group: 'agreement'
      },
      component: () => import('@/pages/agreement/add')
    },
    {
      path: 'agreements/edit/:name/:id',
      name: 'edit.agreement',
      meta: {
        title: 'Agreement',
        group: 'agreement'
      },
      component: () => import('@/pages/agreement/edit')
    },
    {
      path: 'agreements/detail/:name/:id',
      name: 'detail.agreement',
      meta: {
        title: 'Agreement',
        group: 'agreement'
      },
      component: () => import('@/pages/agreement/agreementDetail')
    },
    {
      path: 'agreements/non-commercial',
      name: 'read.non-commercial',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Agreement Non Commercial',
        group: 'non-commercial'
      },
      component: () => import('@/pages/non-commercial/NonCommercialIndex')
    },

    // sales activity
    {
      path: 'sales-activity',
      name: 'read.sales.activity',
      props(route) {
        return route.query || {}
      },
      meta: {
        title: 'Attendance',
        group: 'sales-activity'
      },
      component: () => import('@/pages/SalesActivity/SalesActivityIndex')
    },
    {
      path: 'sales-activity/:name',
      name: 'show.sales.activity',
      meta: {
        title: 'Attendance',
        group: 'sales-activity'
      },
      component: () => import('@/pages/SalesActivity/SalesActivityDetail')
    },
    {
      path: 'customer/merge',
      name: 'read.customer.merge',
      meta: {
        title: 'Customer Merge',
        group: 'customer'
      },
      component: () => import('@/pages/customer/CustomerMerge')
    },
    // customer integration
    {
      path: 'customer/integrations',
      name: 'read.customer.integration',
      meta: {
        title: 'Customer',
        group: 'customer-integration'
      },
      component: () => import('@/pages/customer/integration/IntegrationIndex')
    },
    {
      path: 'customer/integration/:name',
      name: 'show.customer.integration',
      meta: {
        title: 'Customer',
        group: 'customer-integration'
      },
      component: () => import('@/pages/customer/integration/IntegrationDetail')
    },
    {
      path: 'customer/integrations/add',
      name: 'add.customer.integration',
      meta: {
        title: 'Customer',
        group: 'customer-integration'
      },
      component: () => import('@/pages/customer/integration/IntegrationCreate')
    }
  ]
})

// not found
routes.push({
  path: '/*',
  component: () => import('@/pages/notFound.vue')
})

export default routes
